import { Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { FormFieldWrapper } from "../../../form-field-wrapper/FormFieldWrapper";
import { Props } from "./DateField.Parts";
import { ControlledInput } from "./controlled-input/ControlledInput";

export const DateField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>({
  control,
  errors,
  rules,
  label,
  name,
  single,
  disabled,
  placeholder,
  readOnly,
}: Props<FormFields, FieldName>) => {
  return (
    <FormFieldWrapper
      $single={single}
      name={name}
      error={errors[name] as FieldError}
    >
      <Controller
        name={name}
        control={control}
        rules={{ ...rules }}
        render={({ field }) => (
          <ControlledInput
            fieldName={field.name}
            fieldValue={field.value}
            onFieldChange={field.onChange}
            onFieldBlur={field.onBlur}
            label={label}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            hasError={Boolean(errors[name])}
          />
        )}
      />
    </FormFieldWrapper>
  );
};
